import React, { Component } from 'react';
import { QueryVSContext } from '../contexts/QueryVSContext';
import './ValueSetBody.css';
import ValueSetItem from './ValueSetItem';
import ValueSetPage from './ValueSetPage';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import ValueSetDialog from './ValueSetDialog';

class ValueSetBody extends Component {
	state = {
		open: false,
		vsResource: {},
	};

	static contextType = QueryVSContext;

	handleClickOpen = async (e) => {
		//console.log(e);
		const { getResource } = this.context;
		await getResource(e);

		const { resource } = this.context;

		this.setState({ open: true });
		this.setState({ vsResource: resource });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	formatVersion = (x) => {
		if (x) return `Version : ${x}`;
	};

	render() {
		const { bundle, working } = this.context;

		var nextUrl = false;
		var prevUrl = false;

		if (bundle.entry != null) {
			var next = bundle.link.filter((x) => x.relation === 'next');
			nextUrl = next.length === 0 ? false : true;

			var prev = bundle.link.filter((x) => x.relation === 'previous');
			prevUrl = prev.length === 0 ? false : true;

			// console.log(prev);
		}

		const items =
			bundle.entry == null ? this.emptyList() : this.createList(bundle);

		return (
			<React.Fragment>
				<div id="valueSetBody__id" className="valueSetBody">
					<ValueSetPage next={nextUrl} prev={prevUrl} />
					<div className="valueSetBody__list">{items}</div>
					<Backdrop className="valueSetBody__backdrop" open={working} >
						<CircularProgress color="inherit" />
					</Backdrop>
				</div>

				<Dialog fullWidth={true} maxWidth="lg" open={this.state.open}>
					<div className="codeSystemBody__dialogTitleContainer">
						<div className="codeSystemBody__dialogTitleParts">
							ValueSet : {this.state.vsResource.title}
						</div>
						<div className="codeSystemBody__dialogTitleParts">
							{this.formatVersion(this.state.vsResource.version)}
							<div className="pill pill_amber codeSystemBody__dialog-pill">
								{this.state.vsResource.status}
							</div>
						</div>
					</div>

					<ValueSetDialog {...this.state.vsResource} />
					<DialogActions>
						<Button
							onClick={this.handleClose}
							variant="contained"
							color="primary"
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>

			</React.Fragment>
		);
	}

	emptyList() {
		return (
			<div className="snackResponse">
				<MuiAlert elevation={6} variant="filled" severity="warning">No data to display</MuiAlert>
			</div>
		);
	}

	createList(bundle) {
		var items = bundle.entry.map((item) => (
			<ValueSetItem
				className="valueSetBody__valueSetItem"
				item={item.resource}
				key={item.resource.id}
				openFunction={this.handleClickOpen}
			></ValueSetItem>
		));

		// items = '<ValueSetPage/>' + items;

		return items;
	}
}

export default ValueSetBody;
